var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.647461,
    width: 52.5,
    height: 48.8251,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_105_275",
    transform: "translate(0.0349994) scale(0.0103333 0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_105_275",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAABtUlEQVR4nO3bMU7DQBCF4VmK0MAFyCEQHXeBFiEhxKngKggKFBouQlLRPIqEzjbKZPUYo/9rrY3Hf5FqJwIAAAAAAAAh6VjSg6QXSRv1s9n95r2kxVzn6ULSUtJ7x48Zs5K0nNs8Q1oi8nFEvEbEeeaFCauIuGytfc1hnjFHiRfdhu+jIiIuIuJm4nm1eQZlQl8lzhzqeuJZtXkGZf461hFxsu+5A21aa6dzmGdMJrT2PdNDa21w1mrzjMn8dSCB0CaENiG0CaFNCG1CaBNCmxDahNAmhDYhtAmhTQhtQmgTQpsQ2iQTetN9it99TjyrNs+gTOiPxJlDTb2z2jyDMqGfEmcO9TjxrNo8fWh79WpluBX0400TV7GqzdM79tL0cW+SzuY2T1eSFtpe/HuWtO74Mevdb95pv0uOpeYBAACYGRXbGak2TxcqtjNSbZ4h7LB0nmcMOyz7Y4fFiB2Wv55nDDssSeywFEVoE0KbENqE0CaENiG0CaFNCG1CaBNCmxDahNAmhDYhtAmhTQhtwg5LDjssJuywmLDD8tfz9I5damek2jxdqdjOSLV5AAAAAAAA/rNvttW3n3LaPxkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix);
export default __webpack_public_path__ + "static/media/matrix.7303a3e87d0b9560084d4968f40151b8.svg";
export { ForwardRef as ReactComponent };